package pl.michal_cyran.brand_hub.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.withFrameMillis
import com.varabyte.kobweb.browser.dom.observers.IntersectionObserver
import com.varabyte.kobweb.compose.dom.disposableRef
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaIcon
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.BigBadgeStyle

import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLElement

@Composable
fun NumericBadge(
    text: String,
    value: Int,
    unit: String = "",
    durationMs: Long = 1200L,
) {
    VisibilityAware { isVisible ->
        var composeValue by remember { mutableStateOf(0) }

        LaunchedEffect(isVisible, value) {
            if (!isVisible) return@LaunchedEffect

            val startTime = withFrameMillis { it }
            while (true) {
                val now = withFrameMillis { it }
                val progress = ((now - startTime).toFloat() / durationMs).coerceIn(0f, 1f)
                composeValue = (value * progress).toInt()
                if (progress >= 1f) break
            }
            composeValue = value
        }

        Row(
            BigBadgeStyle.toModifier(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(0.cssRem)
        ) {
            H3 { Text(composeValue.toString()) }
            H3(Modifier.padding(right = 1.cssRem).toAttrs()) { Text(unit) }
            H5 { Text(text) }
        }
    }
}